<template>
  <div class="navigate">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="nav-wrap">
          <div class="brand" @click="goHome" aria-label="Go to homepage">
            <img :src="logo" alt="AiLife logo" />
          </div>
          <el-menu :default-active="activeIndex" mode="horizontal" class="navigate_row" router @select="handleSelect">
            <el-submenu index="/test-menu" popper-class="nav-popper">
              <template slot="title">
                <span class="submenu-title">Test Menu</span>
              </template>
              <el-menu-item index="/test/WholeGenomeSequencingProbandOnly">Whole Genome Sequencing</el-menu-item>
              <el-menu-item index="/test/WholeExomeSequencingProbandOnly">Whole Exome Sequencing</el-menu-item>

              <el-submenu index="/test/clinical" popper-class="nav-popper clinical-mega-popper">
                <template slot="title">Clinical Specialties</template>
                <el-menu-item index="/test/category/audiology">Audiology</el-menu-item>
                <el-menu-item index="/test/category/cardiology">Cardiology</el-menu-item>
                <el-menu-item index="/test/category/connective-tissue-and-skin">Connective Tissue and Skin</el-menu-item>
                <el-menu-item index="/test/category/endocrinology">Endocrinology</el-menu-item>
                <el-menu-item index="/test/category/gastroenterology">Gastroenterology</el-menu-item>
                <el-menu-item index="/test/category/genome-wide-cnv-analysis">Genome-Wide CNV Analysis</el-menu-item>
                <el-menu-item index="/test/category/healthy-screening">Healthy Screening</el-menu-item>
                <el-menu-item index="/test/category/hematology">Hematology</el-menu-item>
                <el-menu-item index="/test/category/immunology">Immunology</el-menu-item>
                <el-menu-item index="/test/category/metabolic">Metabolic</el-menu-item>
                <el-menu-item index="/test/category/mitochondrial-genome-sequencing">Mitochondrial Genome Sequencing</el-menu-item>
                <el-menu-item index="/test/category/nephrology">Nephrology</el-menu-item>
                <el-menu-item index="/test/category/neurology">Neurology</el-menu-item>
                <el-menu-item index="/test/category/oncology">Oncology</el-menu-item>
                <el-menu-item index="/test/category/ophthalmology">Ophthalmology</el-menu-item>
                <el-menu-item index="/test/category/pharmacogenomics">Pharmacogenomics</el-menu-item>
                <el-menu-item index="/test/category/pulmonology">Pulmonology</el-menu-item>
                <el-menu-item index="/test/category/repeat-expansion-disorders">Repeat Expansion Disorders</el-menu-item>
                <el-menu-item index="/test/category/skeletal-and-dental">Skeletal and Dental</el-menu-item>
              </el-submenu>
            </el-submenu>
            <el-submenu index="/order">
              <template slot="title"><span class="submenu-title">How To Order</span></template>
              <el-menu-item index="/order/testing">How To Order Testing</el-menu-item>
              <el-menu-item index="/order/specimen">Specimen Requirements</el-menu-item>
              <el-menu-item index="/order/billing">Billing &amp; Insurance</el-menu-item>
              <el-menu-item index="/order/policies">Lab Policies</el-menu-item>
            </el-submenu>
            <el-submenu index="/resources" popper-class="nav-popper">
              <template slot="title"><span class="submenu-title">Resources</span></template>
              <el-menu-item index="/clinical-case-examples">Clinical Case Examples</el-menu-item>
              <el-menu-item index="/products/RequestGeneticistConsultation">Request Geneticist Consultation</el-menu-item>
              <el-menu-item index="/products/VariantInterpretationService">Variant Interpretation Service</el-menu-item>
              <el-menu-item index="/products/Brochures">Product Brochures</el-menu-item>
              <el-menu-item index="/products/UnderstandingResults">Understanding Results</el-menu-item>
            </el-submenu>
            <el-submenu index="/Services" popper-class="nav-popper">
              <template slot="title"><span class="submenu-title">Industry and Research Services</span></template>
              <el-menu-item index="/Services/BioPharmaPartnerships">BioPharma Partnerships</el-menu-item>
              <el-menu-item index="/Services/AilisNGS">
                AilisNGS<sup style="font-size: 0.6em; top: -0.6em; position: relative; margin-left:1px;">&#174;</sup>
              </el-menu-item>
            </el-submenu>
            <!-- <div class="ailis-report-link" @click="goPortal">
              AilisReport<sup>®</sup>
            </div> -->

            <search class="nav-search" />
            <div class="portal-outline" @click="goPortal">Portal Login</div>
          </el-menu>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import picture from "@/utils/img";
import search from "@/views/search";

export default {
  components: { search },
  name: "navigate",
  data() {
    return {
      logo: picture.logo(),
      activeIndex: this.getActiveIndex(this.$route.path),
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.activeIndex = this.getActiveIndex(val.path);
      },
      immediate: true,
    },
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/home" });
    },
    goPortal() {
      window.open("https://report.ailifeus.com", "_blank");
    },
    handleSelect(key) { },
    getActiveIndex(path) {
      return path;
    },
  },
};
</script>

<style lang="scss">
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  text-align: center !important;
  color: $color_black !important;
}

/* =======================================
   下拉菜单 Popper 的滚动条与优化
   ======================================= */
.nav-popper .el-menu--popup {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #dcdfe6;
    border-radius: 4px;
    &:hover {
      background-color: #c0c4cc;
    }
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

/* =======================================
   超长菜单三列布局 (Mega Menu)
   ======================================= */
.clinical-mega-popper {
  .el-menu--popup {
    width: 780px !important;
    display: flex !important;
    flex-wrap: wrap !important;
    flex-direction: row !important;
    padding: 12px !important;
    align-content: flex-start;

    /* 隐藏 Element UI 自动生成的干扰元素 */
    & > div:not(.el-menu-item):not(.el-submenu) {
      display: none !important;
    }

    /* 三列布局中的每一项 */
    .el-menu-item {
      flex: 0 0 calc(33.333% - 10px) !important;
      margin: 2px 5px !important;
      height: 40px !important;
      line-height: 40px !important;
      text-align: left !important;
      padding: 0 12px !important;
      box-sizing: border-box;
      display: flex !important;
      align-items: center;

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    /* 最后一项如果落单（列首），让它占满整行 */
    .el-menu-item:last-child:nth-child(3n + 1) {
      flex: 0 0 calc(100% - 10px) !important;
    }
  }
}

.navigate {
  background: #ffffff;
  height: 100%;

  .el-row {
    padding: 5px 0;
    box-sizing: border-box;
  }

  .nav-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    height: 80px;
  }

  .brand {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    padding: 6px 10px;
    border-radius: 10px;
    flex: 0 0 auto;

    img {
      width: 150px;
      object-fit: contain;
      display: block;
    }
  }

  .el-menu.el-menu--horizontal {
    border: none;
    flex: 1 1 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .el-menu-item:focus,
  .el-menu-item:hover {
    background: none;
  }

  .el-menu-item {
    height: 80px !important;
    line-height: 80px !important;
    color: $color_black !important;
    font-weight: 500;
    font-size: 16px;
  }

  .submenu-title {
    display: inline-flex;
    align-items: center;
    height: 80px;
    line-height: 80px;
    padding: 0 10px;
    color: $color_black;
    font-weight: 500;
    font-size: 16px;
  }

  .nav-popper {
    .el-menu-item {
      height: 44px !important;
      line-height: 44px !important;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .el-submenu__title {
    height: 80px !important;
    line-height: 80px !important;
    padding: 0 10px !important;
  }

  .portal-outline {
    margin-left: 10px;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 700;
    border-radius: 999px;
    cursor: pointer;
    white-space: nowrap;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    background: #1a73e8;
    color: #fff;
    border: none;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 18px rgba(26, 115, 232, 0.25);
    }
  }
}
.ailis-report-link {
  height: 80px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color_black;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1;
  transform: translateY(1px);

  sup {
    font-size: 0.6em;
    position: relative;
    top: -0.45em;
    margin-left: 1px;
    line-height: 1;
  }

  &:hover {
    color: #1a73e8;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/header/header.vue